import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Header.css';

const Header = () => {
  const { user, logout, isAuthenticated } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <span className="logo-text">Property ROI</span>
          <span className="logo-accent">Calculator</span>
        </Link>
        <nav className="nav">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/browse" className="nav-link">Browse</Link>
          {isAuthenticated && <Link to="/search-history" className="nav-link">Search History</Link>}
          <Link to="/subscription" className="nav-link">Pricing</Link>
          <Link to="/contact" className="nav-link">Contact</Link>
          
          {isAuthenticated ? (
            <div className="auth-nav">
              <span className="user-greeting">Hi, {user?.firstName}</span>
              <button onClick={handleLogout} className="nav-link logout-btn">
                Logout
              </button>
            </div>
          ) : (
            <div className="auth-nav">
              <Link to="/login" className="nav-link">Login</Link>
              {process.env.REACT_APP_LOGIN_ONLY_MODE !== 'true' && (
                <Link to="/signup" className="nav-link signup-link">Sign Up</Link>
              )}
            </div>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
